import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationSelectorComponent } from './components/organization-selector/organization-selector.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '../../../common-modules/components/components.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    declarations: [OrganizationSelectorComponent],
    exports: [OrganizationSelectorComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        ComponentsModule,
        ScrollingModule,
    ],
})
export class OrganizationsModule {}
